// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"f568fc01","611":"b42dad46","787":"47af708b"}[chunkId] + ".chunk.js";
};